import { render, staticRenderFns } from "./AboutSwiper3.vue?vue&type=template&id=a8b4132a&scoped=true&"
import script from "./AboutSwiper3.vue?vue&type=script&lang=js&"
export * from "./AboutSwiper3.vue?vue&type=script&lang=js&"
import style0 from "./AboutSwiper3.vue?vue&type=style&index=0&id=a8b4132a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b4132a",
  null
  
)

export default component.exports